// const exclude = ['actions', 'getters', 'mutations', 'namespaced']
function setData(state, module) {
  const data = {}
  // eslint-disable-next-line no-restricted-syntax
  for (const i of module) {
    data[i] = state[i]
  }
  return data
}
export default function Presistent({ key, modules, modulesKeys }) {
  return (store) => {
    const localOldState = JSON.parse(localStorage.getItem(key) || '{}')
    const sessionOldState = JSON.parse(localStorage.getItem(key) || '{}')
    const oldState = {}
    Object.assign(oldState, localOldState, sessionOldState)
    if (Object.keys(oldState).length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const oldKey in oldState) {
        if (Object.prototype.hasOwnProperty.call(oldState, oldKey)) {
          modules[oldKey] = oldState[oldKey]
        }
      }
      store.replaceState(modules)
    }
    store.subscribe((mutation, state) => {
      // 判断是否需要缓存数据至localStorage
      if (modulesKeys.local.length > 0) {
        const localData = setData(store.state, modulesKeys.local)
        localStorage.setItem(key, JSON.stringify(localData))
      } else {
        localStorage.removeItem(key)
      }
      // 判断是否需要缓存数据至localStorage
      if (modulesKeys.session.length > 0) {
        const sessionData = setData(store.state, modulesKeys.session)
        localStorage.setItem(key, JSON.stringify(sessionData))
      } else {
        localStorage.removeItem(key)
      }
    })
  }
}
